import React, { useEffect, useRef } from "react";
import ShipmentMap from "./ShipmentMap";
import ShipmentList from "./ShipmentList";
import CreateShipment from "./CreateShipments";
import { Button } from "@vds/buttons";
import { Box } from "@mui/system";
import ToastNotification from "../../global/components/ToastNotification";
import { useDispatch, useSelector } from "react-redux";
//import dayjs from "dayjs";

import {
  fetchRequest,
  updateUI,
  clearFilter,
  //updateFilter,
  fetchAllRequest,
} from "../../store/actions/shipment";

import "./shipment.css";

function Shipment() {
  const dispatch = useDispatch();
  const {
    shouldUpdate,
    isNotificationActive,
    notification,
    isCreateOpen,
    user,
    //isSingleEditOpen,
  } = useSelector((state) => ({
    shouldUpdate: state.shipment.shouldUpdate,
    notification: state.shipment.ui.notification,
    isNotificationActive: state.shipment.ui.notification.isActive,
    isCreateOpen: state.shipment.ui.create.isOpen,
    //isSingleEditOpen: state.shipment.ui.edit.singleEdit,
    user: state.auth.user,
  }));
  const initialPageLoad = useRef(true);

  // Similar call are being made on line 78
  // useEffect(() => {
  //   dispatch(fetchAllRequest());
  // }, [dispatch, user?.accountId]);

  useEffect(() => {
    let timer = null;
    if (isNotificationActive) {
      dispatch(
        updateUI({
          key: "notification",
          value: {
            isActive: false,
            type: "success",
            message: "",
            description: "",
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
        })
      );
    } else {
      //this avoids multiple api calls at the initial page load due to 4 dependency params
      if (initialPageLoad.current) {
        timer = setTimeout(() => {
          initialPageLoad.current = false;
          dispatch(fetchRequest());
        }, 2000)
      } else {
        dispatch(fetchRequest());
      }
    }
    if(timer){
      return ()=>clearTimeout(timer);
    }
  }, [dispatch, isNotificationActive, shouldUpdate, user?.accountId]);

  useEffect(() => {
    // const state = sessionStorage.getItem("state");
    // const status = sessionStorage.getItem("status");
    // const shipmentName = sessionStorage.getItem("shipmentName");
    // const startDate = sessionStorage.getItem("startDate");
    // const lastUpdated = sessionStorage.getItem("lastUpdated");
    //console.log("state", state, "status", status, "shipmentName", shipmentName, "startDate", startDate, "lastUpdated", lastUpdated);
    //if (!state && !status && !shipmentName && !startDate && !lastUpdated) {
    // dispatch(clearFilter());
    //}
    const lastPathname = sessionStorage.getItem("currentPathname");
    if (!lastPathname?.startsWith("/viewshipment")) {
      dispatch(clearFilter());
    }
    dispatch(fetchAllRequest());
  }, [dispatch, user?.accountId]);

  const createShipment = () => {
    dispatch(
      updateUI({
        key: "create",
        value: {
          isOpen: true,
        },
      })
    );
  };
  return (
    <div
      style={{
        minHeight: "75vh",
        margin: "0 auto",
        display: "row",
        flexDirection: "column",
      }}
    >
      {notification.isActive && (
        <ToastNotification
          type={notification.type}
          message={notification.message}
          description={notification.description}
          duration={1}
          style={notification.style}
        />
      )}
      <Box sx={{ p: 0, width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h2 className="page-common-heading_tittle">Shipments</h2>
          <div style={{ alignContent: "end" }}>
            <Button
              style={{
                marginTop: "-42px",
                fontFamily: "VerizonNHGDS",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "20px",
                letterSpacing: "0.5px",
                textAlign: "center",
              }}
              size="large"
              use="primary"
              onClick={createShipment}
            >
              Add shipment
            </Button>
          </div>
        </div>
      </Box>
      <ShipmentMap />
      <ShipmentList />
      <CreateShipment visible={isCreateOpen} state={null} />
    </div>
  );
}

export default Shipment;
